<template>
  <div id="wishlist-image">
    <div class="card" :class="{ 'card-inactive': isDisable }">
      <div class="card-header">
        <h3 class="card-title title">Картинка</h3>
      </div>
      <div class="card-body">
        <template v-if="hasImage()">
          <div class="mb-3">
            <Lightbox :images="lightboxImages" />
          </div>
        </template>
        <template v-else>
          <div class="mb-3">
            Картинка отсутствует
          </div>
        </template>
        <div class="fallback" v-if="isShowUpload()">
          <input type="file" accept="image/*" @change="onImageChange" />
        </div>
        <div v-if="loadImage" class="mt-3">
          <div class="progress progress-sm">
            <div class="progress-bar progress-bar-indeterminate"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, computed, watch, defineOptions} from "vue"
import "./style.css"
import Api from "./Api"
import Image from "@/services/Image"
import Notify from "@/services/Notify"
import Lightbox from "@/components/lightbox/Lightbox"

const MAX_FILE_SIZE = 5 * 1024 * 1024 // 5 МБ

defineOptions({
  name: "WishlistImage"
})

const props = defineProps({
  payload: {
    type: Object,
    default: () => ({}),
  },
  showUpload: {
    type: Boolean,
    required: true,
    default: true,
  },
})

const emit = defineEmits(['onChange', 'onDelete'])

const image = ref(null)
const loadImage = ref(false)

watch(() => props.payload, (newPayload) => {
  if (newPayload) {
    image.value = newPayload.image || null
  }
}, { immediate: true, deep: true })

const isActive = computed(() => !!props.payload?.wish_id)
const isDisable = computed(() => !isActive.value && !hasImage())

const lightboxImages = computed(() => {
  if (!image.value) {
    return { thumb: [], origin: [] }
  }

  return {
    thumb: [Image.handle(image.value.host, image.value.name, 320)],
    origin: [Image.handle(image.value.host, image.value.name)]
  }
})

const onImageChange = async (e) => {
  const file = e.target.files?.[0]
  if (!file) {
    return
  }

  if (file.size > MAX_FILE_SIZE) {
    Notify.error("Размер картинки не должен превышать 5мб")
    return
  }

  loadImage.value = true
  try {
    const resp = await Api.addImage(props.payload.wish_id, file)

    image.value = {
      host: resp?.image_host ?? null,
      name: resp?.image_name ?? null,
    }

    emit("onChange", {
      success: true,
      resp: { host: image.value.host, name: image.value.name },
    })
  } catch (error) {
    emit("onChange", {
      success: true,
      resp: {},
    })
  } finally {
    loadImage.value = false
    e.target.value = ""
  }
}

function hasImage() {
  return (image.value.host !== null && image.value.name !== null) &&
    (image.value.host !== "" && image.value.name !== "")
}

function isShowUpload() {
  return props.showUpload === true
}
</script>

<style scoped src="./style.css"></style>
